var map = {
	"./24-hours-support.svg": "7f47",
	"./404-error.svg": "bf78",
	"./Address-Info.svg": "1246",
	"./Benefits.svg": "336e",
	"./Billing.svg": "14a0",
	"./CV.svg": "8bfe",
	"./Complaints.svg": "2623",
	"./Contact-info.svg": "453f",
	"./Contractor.svg": "2abc",
	"./Cooperation.svg": "5d8c",
	"./Customer-info.svg": "4a71",
	"./Documentation.svg": "2098",
	"./Fingerprint-scanner.svg": "78ee",
	"./HR-CV.svg": "9067",
	"./Health.svg": "87ab",
	"./Identity.svg": "6449",
	"./Immigration.svg": "83bd",
	"./Insurance.svg": "e879",
	"./Job-info.svg": "51182",
	"./Notes.svg": "6ae8",
	"./Onboarding.svg": "e059",
	"./Payments.svg": "f88b",
	"./Payroll-Info.svg": "d303",
	"./Personal-Details1.svg": "2ba48",
	"./Terms-Conditions.svg": "3012",
	"./Verification.svg": "f8a8",
	"./Visa.svg": "0d64",
	"./account-money.svg": "ae87",
	"./achievement.svg": "e7fb",
	"./add-button.svg": "d401",
	"./add-file.svg": "66f6",
	"./alarm.svg": "df7b",
	"./alert-window.svg": "b3c4",
	"./application-window.svg": "ecae",
	"./application.svg": "e20f",
	"./archive-files.svg": "7c40",
	"./audio-music.svg": "6ef3",
	"./badge.svg": "2974",
	"./barcode.svg": "9ba2",
	"./best-employee.svg": "5dcf",
	"./bitcoin.svg": "c54f",
	"./block-portfolio.svg": "93c9",
	"./book.svg": "0baf",
	"./bookmark-agenda.svg": "9be4",
	"./boxes.svg": "50bd",
	"./bug-window.svg": "9f5c",
	"./buy-button.svg": "c2c1",
	"./calculator.svg": "7a68",
	"./calendar.svg": "bae1",
	"./cash-money.svg": "7df0",
	"./certificate.svg": "9358",
	"./certification.svg": "b994",
	"./chart.svg": "92ea",
	"./chat.svg": "f883",
	"./clipboard-data.svg": "57eb",
	"./cloud-computing-lock.svg": "ec45",
	"./cloud-computing.svg": "a7c9",
	"./cloud-key.svg": "f565",
	"./coding.svg": "f942",
	"./company-templates.svg": "d594",
	"./computer-alert.svg": "e3a1",
	"./computer.svg": "54bd",
	"./contracts.svg": "8e0b",
	"./counter-timer.svg": "1061",
	"./credit-card.svg": "7f1a",
	"./credit-done.svg": "746c",
	"./curriculum--vitae.svg": "6bb6",
	"./dashboard.svg": "7cd5",
	"./data-sheets.svg": "f46e",
	"./database-files.svg": "6006",
	"./database.svg": "fb71",
	"./delete-file.svg": "1fdc",
	"./delivery-truck.svg": "2c53",
	"./design-file.svg": "e764",
	"./details-mail.svg": "9ead",
	"./discount.svg": "6a26",
	"./document-folder.svg": "0892",
	"./document.svg": "75c6",
	"./documents.svg": "93ac",
	"./dollar-coin.svg": "be5e",
	"./edition.svg": "caa9",
	"./email.svg": "6a2a",
	"./employee-CV.svg": "ec17",
	"./envelope-file.svg": "63fe",
	"./envelope.svg": "9bdc",
	"./feature-list.svg": "409e",
	"./file-copy.svg": "1c2d",
	"./file-download.svg": "ffe2",
	"./file-exchange.svg": "3fe7",
	"./file-upload.svg": "18b8",
	"./file.svg": "d2eb",
	"./finance-statistics.svg": "3306",
	"./financial-report.svg": "7d64",
	"./fingerprint-scanner-1.svg": "0547",
	"./floppy-save.svg": "06ac",
	"./folder.svg": "2c20",
	"./gift-card.svg": "35fd",
	"./graduated.svg": "1f9f",
	"./hand-chart.svg": "b420",
	"./headhunter.svg": "e4b4",
	"./headhunting.svg": "dfc3",
	"./home-fences.svg": "dc93",
	"./home.svg": "ddde",
	"./hr-profile.svg": "9a09",
	"./inbox.svg": "c280",
	"./info.svg": "ef13",
	"./information-warning.svg": "186f",
	"./insurance-umbrella.svg": "f7e7",
	"./investment.svg": "6427",
	"./job--interview.svg": "f721",
	"./job--seeker.svg": "30d9",
	"./job-interview.svg": "6161",
	"./job-location.svg": "e0d8",
	"./job-offer.svg": "d5c2",
	"./job-opportunities.svg": "534c",
	"./job-shield.svg": "365b",
	"./job.svg": "a1e8",
	"./key-computer.svg": "1782",
	"./key.svg": "477a",
	"./laptop-like.svg": "30b2",
	"./laptop.svg": "2d08",
	"./location-pin.svg": "041c",
	"./location-shopping.svg": "e9dc",
	"./lock.svg": "4579",
	"./locked-documents.svg": "7232",
	"./mail-lock.svg": "7cdb",
	"./md-photo.svg": "db903",
	"./medical-report.svg": "cecc",
	"./money.svg": "98c9",
	"./multimedia.svg": "9681",
	"./new-offer.svg": "18cf",
	"./offer-delivery-truck.svg": "33fb",
	"./office--building.svg": "73d7",
	"./office--chair.svg": "2524",
	"./office-employee.svg": "6fe6",
	"./online--shopping.svg": "7b9c",
	"./online-resume.svg": "0723",
	"./online-shopping-laptop.svg": "01be",
	"./online-shopping.svg": "ee9e",
	"./open--box.svg": "daf8",
	"./open-24--hours.svg": "33e9",
	"./open-box.svg": "8f16",
	"./open-sign.svg": "b288",
	"./pad-lock.svg": "86db",
	"./padlock.svg": "b5fd",
	"./password.svg": "1555",
	"./percentage-laptop.svg": "69e2",
	"./personal--data.svg": "c13d",
	"./phishing.svg": "64e4",
	"./phone-key.svg": "64b4",
	"./photo.svg": "94aa",
	"./pictures.svg": "f34c",
	"./portfolio.svg": "3025",
	"./profile-check.svg": "d8ab",
	"./profile-folder.svg": "0da8",
	"./profile.svg": "0a81",
	"./profle.svg": "4b7a",
	"./route.svg": "7352",
	"./salary.svg": "7e03",
	"./sale-tag.svg": "0868",
	"./save-floppy-disk.svg": "e34f",
	"./schedule.svg": "27ac",
	"./search-file.svg": "b57a",
	"./search-files.svg": "d058",
	"./secure-folder.svg": "65bc",
	"./secure-user.svg": "f42d",
	"./server.svg": "2714",
	"./setting-window.svg": "16ca",
	"./she-profile.svg": "ffd6",
	"./shield.svg": "8753",
	"./shopping--bag.svg": "58a4",
	"./shopping-bag.svg": "a75d",
	"./shopping-basket.svg": "6f74",
	"./shopping-cart-add.svg": "3295",
	"./shopping-cart-two.svg": "29090",
	"./shopping-cart.svg": "79fd",
	"./shopping.svg": "0606",
	"./skill.svg": "ede2",
	"./smart--phone.svg": "46e2",
	"./smart-phone.svg": "e031",
	"./smartphone.svg": "f985",
	"./sound-volume.svg": "bc31",
	"./star-add.svg": "bbd5",
	"./status-report.svg": "fc9e",
	"./table-data.svg": "aad9",
	"./target-headhunter.svg": "df15",
	"./target.svg": "88d8",
	"./text-file.svg": "6b18",
	"./traffic-cone.svg": "56a4",
	"./traffic-sign.svg": "c150",
	"./trash-files.svg": "3ab7",
	"./trophy.svg": "e43e",
	"./upload-cloud.svg": "d27d",
	"./user-data.svg": "2648",
	"./user-login.svg": "1867",
	"./user.svg": "8d4f",
	"./video-files.svg": "c212",
	"./wall-secure.svg": "a94c",
	"./wallet-money.svg": "9e07",
	"./wallet.svg": "bab4",
	"./window-cart.svg": "c1505",
	"./window-lock.svg": "e14e",
	"./window-volume.svg": "c0fc",
	"./window.svg": "4a27",
	"./working.svg": "313b",
	"./zip.svg": "ca7d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c8f0";